//React component for survey-specific components
//Since these components are used in both the participant/designer app
import React from 'react';
import { createRoot } from 'react-dom/client';
import SurveyQuestion from '../../components/Survey/Components/SurveyQuestion/SurveyQuestion';
import SurveyForm from '../../components/Survey/Components/SurveyForm/SurveyForm';
import SurveyHeader from '../../components/Survey/Components/SurveyHeader/SurveyHeader';
import { TranslateContext } from "../MyDataHelps/TranslateContext";
import { SurveyStepContext } from '../../components/Survey/Util/surveyStepContext';
import SurveyMarkdown from '../../components/presentational/SurveyMarkdown/SurveyMarkdown';

const getComponent = (component, props) => {
	if (component === 'SurveyQuestion') {
		return <SurveyQuestion {...props} />;
	}
	if (component === 'SurveyForm') {
		return <SurveyForm {...props} />;
	}
	if (component === 'SurveyHeader') {
		return <SurveyHeader {...props} />;
	}
	if (component === 'SurveyMarkdown') {
		return <SurveyMarkdown {...props} />;
	}
}

angular.module('ResearchKitApplicationModule').component('surveyReactComponent', {
	template: '<div></div>',
	bindings: {
		'component': '@',
		'props': '=',
		'mode': "=",
		'stepType': "@",
		'stepIdentifier': "=",
		'markdownFormat': "="
	},
	controller: ['$element', '$scope', '$injector', '$translate', function ($element, $scope, $injector, $translate) {
		const $ctrl = this;

		const render = (component, props) => {
			$ctrl.root.render(
				<SurveyStepContext.Provider value={{ mode: $ctrl.mode || "Survey", stepType: $ctrl.stepType || "QuestionStep", stepIdentifier: $ctrl.stepIdentifier, markdownFormat: $ctrl.markdownFormat }}>
					<TranslateContext.Provider value={$translate}>
						{getComponent(component, props)}
					</TranslateContext.Provider>
				</SurveyStepContext.Provider>
			);
		}

		function renderComponent() {
			var props = $ctrl.props ? { ...$ctrl.props } : {};
			props.$scope = $scope;
			props.$injector = $injector;
			render($ctrl.component, props);
		}

		$ctrl.$onInit = () => {
			$ctrl.root = createRoot($element[0]);
			renderComponent();
			$scope.$watch('$ctrl.props', function () {
				renderComponent();
			});
		}

		$ctrl.$onDestroy = () => $ctrl.root.unmount();
	}]
});